module.exports = __webpack_public_path__ + "static/media/land-elife-banner-img-mobile.5487f77e.jpg";